import { Component, NgZone, OnInit } from "@angular/core";
import { authenticationService } from "src/app/Services/Authentication/authentication.service";
import { ViewController } from "@ionic/core";
import {
  ActionSheetController,
  AlertController,
  LoadingController,
  ModalController,
  NavParams,
  PopoverController,
} from "@ionic/angular";
import { SharedService } from "src/app/Services/sheared/sharedService.service";
import { Router } from "@angular/router";
import { AssureurService } from "src/app/Services/Assureur/assureur.service";
import { CotationVoyageService } from "src/app/Services/Cotation/cotationVoyage.service";
import { FactoryService } from "src/app/Services/historique/factory.service";
import { PaiementService } from "src/app/Services/Paiement/paiement.service";
import { CotationMrhService } from "src/app/Services/Cotation/cotationMrh.service";

@Component({
  selector: "app-mrh",
  templateUrl: "./mrhresprime.component.html",
  styleUrls: ["./mrhresprime.component.scss"],
})
export class MrhResPrimeComponent implements OnInit {
  dtjr: string;
  objetpass: any;
  itemsData: any[] = [];
  private items: any[];
  select_Assureur: any = null;
  assureurs = [];
  selectedImage: string;
  fileList: string[] = [];
  textImageselect: boolean;
  isEnabled: boolean = false;
  TypeObjet: string = "";
  afficheVoyage: boolean = false;
  //subs = new Subscription
  loading: HTMLIonLoadingElement;
  options = {
    centeredSlides: true,
    loop: false,
    spaceBetween: -50,
  };
  constructor(
    private viewCtrl: PopoverController,
    private shear: SharedService,
    private auth: authenticationService,
    private modalCtrl: ModalController,
    private assureurService: AssureurService,
    private _sheard: SharedService,
    private actionSheetCtrl: ActionSheetController,
    private alertController: AlertController,
    private loadingController: LoadingController,
    private _fact: FactoryService,
    private _primeService: PaiementService,
    private _cotationMrhService: CotationMrhService,
    private _route: Router,
    private ngZ: NgZone,
    private nvparms: NavParams
  ) {
    this.objetpass = this.nvparms.get("value");

    this.objetpass.CodeAssur = this._fact.getData(201);
    this.objetpass.open = true;
    //this.dtjr = this._sheard.ConvertDMYorYMD(this._sheard.getDate());
    this.assureurService.getAssureurs();
  }

  ngOnInit() {
    this.TypeObjet = "MULTIRISQUE";
    let timer = setTimeout(() => {
      this.itemsData.push(this.objetpass);
      clearTimeout(timer);
    }, 100);
    this.assureurService.ListAssreurs.subscribe((res) => {
      try {
        this.assureurs = res;
      } catch (error) {}
    });

    this._fact.seTtracking(new Date().toISOString(),
    'L5',
    false,
    '1000',
    "",
    "Prime Mrh",
    "")
  }
  onValider(item) {
    //this.objetpass.cartegrise=this.selectedImage

    this.presentPayment(item);
  }

  private async presentPayment(nameSelected) {
    let dateEffet = this._sheard.getDateWithTimeDMY();
    let jrs;
    let dateExpi;

    if (
      nameSelected.periode == "12 mois" ||
      nameSelected.periode == "365 jours"
    ) {
      dateExpi = this._sheard.ConvertDMYorYMD(
        this._sheard.getDate(
          this._sheard.AddDays(
            this._sheard.getDate(),
            this._sheard.DayOfyear(new Date()) - 1
          )
        )
      );
    }

    jrs = 365;
    nameSelected.periode = jrs + " jours";

    const alert = await this.alertController.create({
      header: "Paiement de la prime",
      mode: "ios",
      message:
        "Vous avez choisi une couverture d'une durée de <strong>" +
        nameSelected.periode +
        "</strong>. Ce contrat d'assurance prendra donc effet à :" +
        "<p>*Date éffet <strong>" +
        dateEffet +
        "</strong></p>" +
        "<p>*Date expiration <strong>" +
        dateExpi +
        "</strong></p>" +
        "<p><strong>NB:</strong> Si vous reportez le paiement de la prime à un autre jour," +
        "la date d'effet sera la date de paiement </p><br>",

      buttons: [
        {
          text: "Annuler",
          role: "cancel",
          cssClass: "primary",
          handler: () => {
            //this._objet = "Selectionner l'objet"
          },
        },
        {
          text: "OK",
          handler: () => {
            this.objetpass.dateEffet = dateEffet;
            this.objetpass.dateExpi = dateExpi;
            this.objetpass.duree = jrs;
            this.controlDeProvenance(this.TypeObjet);
          },
        },
      ],
    });
    await alert.present();
  }
  onLogout() {
    this.auth.onLogout();
    this.viewCtrl.dismiss();
  }
  PayerPrimer() {
    this.controlDeProvenance(this.TypeObjet);
  }
  async controlDeProvenance(_objet: any = null) {
    this.loading = await this.loadingController.create({
      message: "Envoi en cours...",
      duration: 30 * 1000,
      mode: "ios",
      spinner: "bubbles",
    });
    this.loading.present();
    this._fact.setData(30, []);

    //#region AUTOMOBILE and INDIVIDUELLE
    let duree = 0;

    duree = Math.round(this._sheard.DayOfyear(new Date()));

    let police = `MRH-${this._sheard.generatorPolice()}`;
    this.items = [];
    this.objetpass.CodeAssur = this._fact.getData(201);
    this.items.push({
      NumPolice: police,
      police: police,
      NomPrenom: this.auth.profile.NomPrenom,
      Notification: "",
      CodeAssur: this.objetpass.CodeAssur,
      NumRef: "",
      dateEffet: this.objetpass.dateEffet,
      dateExpi: this.objetpass.dateExpi,
      montant_due: this.objetpass.Ttc,
      montant_paye: 0,
      date_paiement: "",
      dateInsert: this._sheard.getDate(),
      etatdoc: "",
      icon: "../../../../assets/icon/home.svg",
      flag: false,
      //isChecked:true,
      notifydoc: false,
      notify: true,
      CodeMvt: "AFN",
      duree: duree,
      mode_paie: "",
      numClient: "", //this.auth.profile.numClient,
      solde: false,
      type: "mrh",
      idKey: this.auth.profile.uid,
    });

    this._primeService.insertPrime(this.items).then((res) => {
      this.items[0].$key = res.key;
      this.items[0].nbPaie = 0;
      this.items[0].montantVerse = 0;
      this.items[0].montant_restant = this.objetpass.Ttc;
      this._fact.setData(30, this.items[0]);
      // if (isUndefined(this.objetpass.CodeAssur)) {
      //   this._primeService.addQuit(res.key,this.objetpass.CodeAssur)
      //   }
      this.uploadingMrh(res.key, police);
    });
  }
  private uploadingMrh($key: string, police) {
    const data = this._fact.getData(150);
    data.CodeAssur = this.objetpass.CodeAssur;
    data.dateEffet = this.objetpass.dateEffet;
    data.dateExpi = this.objetpass.dateExpi;
    data.dateInsert = this._sheard.getTimeStampFromToday();
    data.Police = police;
    data.Quittance = $key;
    (data.icon = "../../../../assets/img/mrh.png"), (data.type = "Mrh");
    this._fact.seTtracking(new Date().toISOString(),
    'L6',
    false,
    '1000',
    "",
    "Enregistrement Mrh",
    police)
    this._cotationMrhService
      .insertNewMrh(data)
      .then(() => {
        this.loading.dismiss().then((res) => {
          if (res) {
            this.modalCtrl.dismiss().then((res) => {
              if (res) {
                this._route.navigate(["prime", 30], { replaceUrl: true });
              }
            });
          }
        });

        // setTimeout(() => {

        // });
      })
      .catch((error) => console.error(error))
      .finally(() => this.loading.dismiss());
  }
}
